/**
 * Background blur, shared by the preview and the call. The plugin pulls in
 * TensorFlow, so it is only downloaded the first time someone turns blur on,
 * and one instance is reused so the model loads once.
 */
let pluginPromise = null;
let pluginName = null;

export function loadBlurPlugin() {
  if (!pluginPromise) {
    pluginPromise = import("@100mslive/hms-virtual-background")
      .then(async ({ HMSVirtualBackgroundPlugin }) => {
        const plugin = new HMSVirtualBackgroundPlugin("blur");
        await plugin.init();
        await plugin.setBackground("blur");
        pluginName = plugin.getName();
        return plugin;
      })
      .catch(error => {
        pluginPromise = null;
        throw error;
      });
  }
  return pluginPromise;
}

/** The plugin's name once loaded, to look it up in the store. */
export function getBlurPluginName() {
  return pluginName;
}

const BLUR_FRAME_RATE = 15;

export async function setBlur(hmsActions, enabled) {
  const plugin = await loadBlurPlugin();
  if (enabled) {
    // The plugin's own check (browser support). hmsActions'
    // validateVideoPluginSupport looks the camera up among published tracks,
    // so it fails on the preview, before joining.
    const { isSupported, errMsg } = plugin.checkSupport();
    if (!isSupported) {
      throw new Error(errMsg || "Background blur is not supported here");
    }
    await hmsActions.addPluginToVideoTrack(plugin, BLUR_FRAME_RATE);
  } else {
    await hmsActions.removePluginFromVideoTrack(plugin);
  }
}
